import { Card } from "@mui/material";
import { useEffect, useState } from "react";
import { CheckBoxOutlined, CropSquareOutlined } from "@mui/icons-material";

import Box from "../Box";
import Button from "../Button";
import Avatar from "../Avatar";
import DataTable from "../DataTable";
import Typography from "../Typography";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import ModalUpdateGroupUser from "./modalUpdateGroupUser";
import ModalInvitationMember from "../Staff/modalInvitationMember";
import ModalSearchUser, { IRecordUserProps } from "../ModalSearchUser";
import UserGroupService from "../../services/identity/userGroup.service";

import { ICodename } from "../../commons/interfaces";
import { Constants } from "../../constants/constants";
import { RoleHelpers } from "../../commons/roleHelpers";
import { commonGetAllDataRole } from "../../containers/role/list";
import { getAllDataCodename } from "../../containers/codename/list";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
import { IDataDetailGroup, IGroupUserResponses } from "../../containers/group/edit";
import { ActionRequest, CodeNameCommon, GroupType, GroupUserDefault, IsTrue, Mode, Status } from "../../constants/enums";




const CardListUserByGroup = (props: {
    mode: number;

    newDomain?: string;
    newLableGroup?: string;
    newLableStaff?: string;

    listUserIdSelected?: string[];
    dataDetailGroup?: IDataDetailGroup;

    dataRowsUserGroup?: (IGroupUserResponses & { action: number; })[];
    onCallBack?: (data?: {
        userId?: string[],
        rows?: (IGroupUserResponses & { action: number; })[],
    }) => void;

    hidenActionCreateMember?: boolean,
    hidenActionUpdateMember?: boolean,
    hidenActionDeleteMember?: boolean,
    hidenActionInvitationMember?: boolean,

    modalCreateMember?: (props: {
        groupId?: string;
        organizationId: string;
        onCallBack?: () => void
    }) => JSX.Element;
    modalInvitationMember?: (props: {
        groupId?: string;
        organizationId: string;
        onCallBack?: () => void
    }) => JSX.Element;
}) => {

    const strings = useStrings();

    const {
        clientId, userInfo, serviceCode,
        onError, onSuccess, onShowLoading, onHideLoading
    } = useCommonComponentContext();

    const [listUserRole, setListUserRole] = useState<ICodename[]>([]);
    const [listUserTitle, setListUserTitle] = useState<ICodename[]>([]);

    const [openModalAddUser, setOpenModalAddUser] = useState<boolean>(false);
    const [dataUserGroup, setDataUserGroup] = useState<(IGroupUserResponses & { action: number })[]>([]);
    const [itemUserGroup, setItemUserGroup] = useState<(IGroupUserResponses & { action: number }) | undefined>(undefined);

    useEffect(() => {
        setDataUserGroup([...props.dataRowsUserGroup || []]);
    }, [props.dataRowsUserGroup]);

    useEffect(() => {
        (async () => {
            if (!Helpers.isNullOrEmpty(props.dataDetailGroup?.id)) {
                // Get Data UserRole
                let listRoleTemp: ICodename[] = await commonGetAllDataRole({
                    clientId: clientId,
                    status: Status.Active,
                    organizationId: userInfo?.userProfile?.organizationId,
                });

                setListUserRole(listRoleTemp);

                // Get Data UserTitle
                const resultGetAllCodeName = await getAllDataCodename({
                    serviceCode: serviceCode,
                    group: [CodeNameCommon.USER_TITLE],
                    organizationId: userInfo?.userProfile?.organizationId,
                });

                const resultGetAllGroupUserTitle = resultGetAllCodeName.get(CodeNameCommon.USER_TITLE) || [];

                setListUserTitle(resultGetAllGroupUserTitle);
            }
        })()
    }, [
        clientId,
        serviceCode,
        userInfo?.userProfile?.organizationId,
        props.dataDetailGroup?.id,
    ]);

    // #region Delete Member in Group
    const handleDeleteUserGroup = (idItem: string) => {
        const newMsgConfirm = strings.format(strings.Group.CONFIRM_USER_BY_GROUP_DELETE, props.newLableStaff, props.newLableGroup);

        Helpers.showConfirmAlert(
            newMsgConfirm,
            async () => {
                try {
                    onShowLoading();

                    await UserGroupService.delete({
                        id: idItem,
                        organizationId: userInfo?.userProfile?.organizationId,
                        isInvitationDetail: false,
                    });

                    const dataTemp = [...dataUserGroup || []].filter((el) => el.id !== idItem);

                    const userIdsTemp = dataTemp.map(el => el.userId);

                    setDataUserGroup(dataTemp);

                    props.onCallBack && props.onCallBack({ rows: dataTemp, userId: userIdsTemp });

                    const newMsg = strings.format(strings.Group.DELETE_USER_BY_GROUP_SUCCESS, props.newLableStaff, props.newLableGroup);

                    onSuccess(newMsg);

                } catch (error) {
                    const e = Helpers.renderExceptionError(error);
                    onError(e);
                } finally {
                    onHideLoading();
                }
            }
        )
    };

    // #region Update Member in Group
    const handleUpdateUserGroup = async (newItem: IGroupUserResponses & { action: number }) => {
        try {
            onShowLoading();

            await UserGroupService.update(({
                id: newItem?.id,
                organizationId: userInfo?.userProfile?.organizationId,
                userId: newItem?.userId,
                groupId: newItem?.groupId,
                manager: newItem?.manager,
                default: newItem?.default,
                userTitle: newItem?.userTitle,
            }))

            const dataRowsTemp = [...dataUserGroup || []];
            const index = dataRowsTemp.findIndex((el) => (el.id === newItem?.id));

            if (index !== -1) {
                dataRowsTemp[index] = { ...newItem };

                setDataUserGroup(dataRowsTemp);
            };

            onSuccess(strings.Staff.UPDATE_USER_GROUP_SUCCESS);
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };


    // #endregion Update Member in Group

    // #region Invite Member in Group
    const RenderModalInviteMemberByGroup = (): JSX.Element => (
        props.modalInvitationMember
            ? props.modalInvitationMember({
                groupId: props.dataDetailGroup?.id,
                organizationId: userInfo?.userProfile?.organizationId || "0",
                onCallBack() {
                    props.onCallBack &&
                        props.onCallBack();
                },
            })
            : <ModalInvitationMember
                newDomain={props.newDomain}

                lableStaff={props.newLableStaff}
                lableGroup={props.newLableGroup}
                groupId={props.dataDetailGroup?.id}
                organizationId={userInfo?.userProfile?.organizationId || "0"}

                groupList={[]}
                roleList={[...listUserRole || []]}

                onCallBack={() => {
                    props.onCallBack &&
                        props.onCallBack();
                }}
            />
    );

    // #region Add Member in Group
    const onCallAPICreateUserGroup = async (newReq: any) => {
        try {
            await UserGroupService.create(newReq);
            return newReq.userId as string;
        } catch (error) {
            return "";
        }
    };

    const handleCreateUserGroup = async (newData: IRecordUserProps[]) => {
        try {
            onShowLoading();

            const newReq: any[] = [];
            for (const item of newData) {
                if (![...props.listUserIdSelected || []].includes(item.id)) {
                    newReq.push({
                        userId: item.id,
                        clientId: clientId,
                        groupId: props.dataDetailGroup?.id,
                        organizationId: userInfo?.userProfile?.organizationId || "0",

                        userTitle: undefined,
                        manager: IsTrue.False,
                        default: GroupUserDefault.None,
                    });
                }
            };

            await Promise.all(newReq.map(el => (onCallAPICreateUserGroup(el))));

            props.onCallBack && props.onCallBack();

            const newMsg = strings.format(strings.Group.CREATE_USER_BY_GROUP_SUCCESS, props.newLableStaff, props.newLableGroup);

            onSuccess(newMsg);
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
            setOpenModalAddUser(false);
        }
    };

    const RenderModalAddNewUserGroup = (): JSX.Element => (
        props.modalCreateMember
            ? props.modalCreateMember({
                groupId: props.dataDetailGroup?.id,
                organizationId: userInfo?.userProfile?.organizationId || "0",
                onCallBack() {
                    props.onCallBack && props.onCallBack();
                },
            })
            : (
                <>
                    <Button onClick={() => { setOpenModalAddUser(true); }}>
                        {strings.format(strings.Organization.ADD_STAFF, props.newLableStaff)}
                    </Button>
                    {openModalAddUser &&
                        <ModalSearchUser
                            userIds={[]}
                            open={openModalAddUser}
                            userIdsDisable={props.listUserIdSelected}

                            onClose={() => {
                                setOpenModalAddUser(false);
                            }}
                            onAction={(data) => {
                                handleCreateUserGroup(data)
                            }}
                        />
                    }
                </>
            )
    );
    // #endregion Add Member in Group

    return (
        <Card>
            <Box p={2}>
                <Box sx={{
                    gap: 1,
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}>
                    <Typography variant="h5">
                        {strings.format(strings.Staff.TITLE_LIST_VIEW, props.newLableStaff)}
                    </Typography>
                    {
                        (props.mode !== Mode.View) &&
                        (!props.hidenActionInvitationMember || !props.hidenActionCreateMember) &&
                        <Box sx={{
                            gap: 1,
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                        }}>
                            {!props.hidenActionInvitationMember &&
                                <RenderModalInviteMemberByGroup />
                            }
                            {!props.hidenActionCreateMember &&
                                <RenderModalAddNewUserGroup />
                            }
                        </Box>
                    }
                </Box>

                <Box p={2}>
                    <DataTable
                        isLocal
                        pageNumber={1}
                        mode={props.mode}
                        totalCount={dataUserGroup.length}
                        rowPerPage={Constants.ROW_PER_PAGE}
                        hideActionMenu={props.mode === Mode.View}
                        table={{
                            rows: dataUserGroup.filter((el) => (el.action !== ActionRequest.Delete)),
                            columns: [
                                {
                                    Header: strings.Staff.FULL_NAME, accessor: "userId", width: "250px",
                                    Cell: (row) => {
                                        const valueTemp = { ...row.row?.original?.userProfile };

                                        let fullName = valueTemp.email;

                                        if (!Helpers.isNullOrEmpty(valueTemp?.firstName)
                                            || !Helpers.isNullOrEmpty(valueTemp?.lastName)) {
                                            fullName = `${valueTemp?.lastName || ""} ${valueTemp?.firstName || ""}`.trim();
                                        }

                                        return (
                                            <Box display="flex" alignItems="center">
                                                <Avatar
                                                    alt="avt-staff"
                                                    src={valueTemp?.avatarUrl}
                                                    text={valueTemp?.firstName}
                                                    sx={{
                                                        width: "36px",
                                                        height: "36px",
                                                        objectFit: "cover",
                                                        marginRight: "8px",
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                                <Box display="grid">
                                                    <Typography
                                                        color="text"
                                                        variant="caption"
                                                        fontWeight="medium"
                                                    >
                                                        {fullName}
                                                    </Typography>
                                                    {!Helpers.isNullOrEmpty(valueTemp?.phoneNumber) &&
                                                        <Typography
                                                            color="secondary"
                                                            variant="caption"
                                                        >
                                                            sđt:&nbsp;{valueTemp?.phoneNumber}
                                                        </Typography>
                                                    }
                                                    {!Helpers.isNullOrEmpty(valueTemp?.email) &&
                                                        <Typography
                                                            color="secondary"
                                                            variant="caption"
                                                        >
                                                            email:&nbsp;{valueTemp?.email}
                                                        </Typography>
                                                    }
                                                </Box>
                                            </Box>
                                        )
                                    },
                                },
                                {
                                    Header: Helpers.capitalizeFirstLetter(strings.format(strings.Staff.MANAGER_GROUP, props.newLableGroup)), accessor: "manager",
                                    Cell: (row) => (Number(row.value) === IsTrue.True ? <CheckBoxOutlined /> : <CropSquareOutlined />),
                                },
                                {
                                    Header: Helpers.capitalizeFirstLetter(strings.format(strings.Staff.STAFF_POSITION, props.newLableStaff)), accessor: "userTitle",
                                    Cell: (row) => <>{listUserTitle.find((e) => e.code === row.value)?.name}</>,
                                },
                            ],
                        }}

                        actionList={(row) => {
                            let isEdit: boolean = false;

                            if (props.dataDetailGroup?.type === GroupType.Company) {
                                isEdit = row.userId !== userInfo?.userProfile?.identityId;
                            } else {
                                isEdit = true;
                            }

                            return [
                                isEdit &&
                                !props.hidenActionUpdateMember &&
                                {
                                    key: "edit",
                                    iconName: "edit",
                                    title: strings.Common.EDIT,
                                    callback: (row) => {
                                        setItemUserGroup(row);
                                    },
                                },
                                isEdit &&
                                !props.hidenActionDeleteMember &&
                                {
                                    key: "delete",
                                    iconName: "delete",
                                    title: strings.Common.DELETE,
                                    callback: (row) => {
                                        handleDeleteUserGroup(row.id);
                                    },
                                },
                            ];
                        }}
                    />
                </Box>

                {!Helpers.isNullOrEmpty(itemUserGroup?.id) &&
                    <ModalUpdateGroupUser
                        dataUserGroup={itemUserGroup}

                        listUserTitle={listUserTitle}
                        newLableGroup={props.newLableGroup}
                        newLableStaff={props.newLableStaff}

                        onClose={() => {
                            setItemUserGroup(undefined);
                        }}
                        onSubmit={(newItem) => {
                            handleUpdateUserGroup(newItem);
                            setItemUserGroup(undefined);
                        }}
                    />
                }
            </Box>
        </Card>
    );
};

export default CardListUserByGroup;